var map = {
	"./adream.svg": 4642,
	"./article-0.jpg": 7664,
	"./article-1.jpg": 7453,
	"./article-2.jpg": 4805,
	"./article-3.jpg": 8023,
	"./article-4.jpg": 5686,
	"./article-5.jpg": 607,
	"./article-6.jpg": 1476,
	"./contest-widget-bg.jpg": 5615,
	"./contest-widget-disneyland.svg": 8826,
	"./favicon.png": 580,
	"./file-blank.svg": 4490,
	"./file-jpeg.svg": 9758,
	"./file-pdf.svg": 5953,
	"./file-rar.svg": 2533,
	"./file-zip.svg": 1173,
	"./fox-books.png": 9062,
	"./fox-love.png": 7546,
	"./fox-search-small.png": 5429,
	"./fox-search.png": 2395,
	"./fox.png": 2219,
	"./gdynia-jarmark.svg": 8359,
	"./legendia.svg": 7311,
	"./logo-alicja-black.svg": 6623,
	"./logo-alicja.svg": 3045,
	"./logo-horizontal.svg": 1908,
	"./logo-ks.svg": 156,
	"./logo-la.svg": 7694,
	"./logo-pp.svg": 2430,
	"./logo-vertical-white.svg": 1989,
	"./logo-vertical.svg": 4666,
	"./muzeum.svg": 1905,
	"./newsletter-fox-image.png": 5721,
	"./platinum.svg": 7461,
	"./project-video.jpg": 2912,
	"./realization-1.jpg": 8686,
	"./realization-2.jpg": 5943,
	"./realization-3.jpg": 1955,
	"./realization-4.jpg": 4600,
	"./slider-general.jpg": 2636,
	"./slider-general_mobile.jpg": 1373,
	"./slider-ks-mobile.jpg": 9041,
	"./slider-ks.avif": 8357,
	"./slider-ks.jpg": 4029,
	"./slider-la-mobile.jpg": 6062,
	"./slider-la.avif": 5567,
	"./slider-la.jpg": 8977,
	"./slider-pp-mobile.jpg": 2180,
	"./slider-pp.avif": 3194,
	"./slider-pp.jpg": 3349,
	"./slideshow-1.jpg": 3000
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;